var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.73 1l7.972 7.434-7.971 7.454v-4.31c-3.452.15-5.755 1.312-7.559 3.74L1 18.24l.747-3.564C2.77 9.802 5.524 6.454 10.402 5.42l.329-.066V1zm1.6 5.731l-.69.096c-3.608.501-5.965 2.289-7.319 5.111 1.9-1.35 4.236-1.978 7.21-1.978h.8v2.242l4.027-3.766-4.027-3.756V6.73z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.450a742e7292bf382e71edf67b48c899.svg";
export { ForwardRef as ReactComponent };